// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"297":"aa31427a","389":"aa31427a","943":"aa31427a"}[chunkId] + ".chunk.css";
};